"use strict";
import s from "./index.es99.js";
function f(i) {
  return s.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
}
function a(i) {
  const o = {}, n = Object.keys(i);
  let e;
  const t = n.length;
  let u;
  for (e = 0; e < t; e++)
    u = n[e], o[u] = i[u];
  return o;
}
function h(i) {
  function o(n, e, t, u) {
    let r = n[u++];
    if (r === "__proto__") return !0;
    const c = Number.isFinite(+r), l = u >= n.length;
    return r = !r && s.isArray(t) ? t.length : r, l ? (s.hasOwnProp(t, r) ? t[r] = [t[r], e] : t[r] = e, !c) : ((!t[r] || !s.isObject(t[r])) && (t[r] = []), o(n, e, t[r], u) && s.isArray(t[r]) && (t[r] = a(t[r])), !c);
  }
  if (s.isFormData(i) && s.isFunction(i.entries)) {
    const n = {};
    return s.forEachEntry(i, (e, t) => {
      o(f(e), t, n, 0);
    }), n;
  }
  return null;
}
export {
  h as default
};
//# sourceMappingURL=index.es104.js.map
